/**
 * CustomerSpeed.API
 * API that manages account-specific speed limit overrides.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * DTO for updating an existing speed override. Uses the same flat structure as the create request. The update is a full replacement (PUT): Name, Direction, SpeedOverwriteInKmh, and StartDate are required.
 */
export interface UpdateOverrideDto {
  /**
   * The user-defined name for this override. Example: \"US-101 Construction Zone (Extended)\"
   */
  name: string | null;
  /**
   * The direction of travel for this override (FORWARD, BACKWARD, or BOTH).
   */
  direction: UpdateOverrideDto.DirectionEnum;
  /**
   * The speed override value in km/h.
   */
  speedOverwriteInKmh: number;
  /**
   * The start date for when the override becomes active.
   */
  startDate: string;
  /**
   * Optional end date for when the override expires.
   */
  endDate?: string | null;
  /**
   * Optional notes about this override (max 100 characters).
   */
  notes?: string | null;
}
export namespace UpdateOverrideDto {
  export type DirectionEnum = 'FORWARD' | 'BACKWARD' | 'BOTH';
  export const DirectionEnum = {
    Forward: 'FORWARD' as DirectionEnum,
    Backward: 'BACKWARD' as DirectionEnum,
    Both: 'BOTH' as DirectionEnum
  };
}
